import { options, translations as commonTranslations } from 'lang/sv'

/**
 * Admin translations
 * \u00AD is soft hyphen to make word breaks in good places small screens
 */
const translations = Object.assign(commonTranslations, {
  // Page titles
  'title.base': 'Fakturatjänst',
  'title./': 'Hem',
  'title./logga_in': 'Logga in',
  'title./valj_orgkonto': 'Välj organisationskonto',
  'title./organisation': 'Organisation',
  'title./organisation/admin/ny': 'Skapa ny organisations\u00ADadministratör',
  'title./organisation/admin/visa/:id': 'Organisations\u00ADadministratör',
  'title./organisation/admin/andra/:id':
    'Ändra organisations\u00ADadministratör',
  'title./orgkonto': 'Konton',
  'title./orgkonto/ny': 'Konton',
  'title./orgkonto/andra': 'Konton',
  'title./orgkonto/orgadmin/ny': 'Skapa ny konto\u00ADadministratör',
  'title./orgkonto/orgadmin/visa/:id': 'Konto\u00ADadministratör',
  'title./orgkonto/orgadmin/andra/:id': 'Ändra konto\u00ADadministratör',
  'title./fakturamottagare': 'Fakturamottagare',
  'title./fakturamottagare/ny': 'Skapa ny faktura\u00ADmottagare',
  'title./fakturamottagare/visa/:id': 'Faktura\u00ADmottagare',
  'title./fakturamottagare/andra/:id': 'Ändra faktura\u00ADmottagare',
  'title./kopare': 'Köpare',
  'title./kopare/ny': 'Skapa ny köpare',
  'title./kopare/visa/:id': 'Köpare',
  'title./kopare/andra/:id': 'Ändra köpare',
  'title./kop': 'Köp',
  'title./kop/:id': 'Köp',
  'title./faktura': 'Faktura',
  'title./faktura/:id': 'Faktura',
  'title./fel': 'Fel',
  'title./hjälp': 'Hjälp',

  'url.new_admin_url_description': 'Inkopstjanst.coop.se har bytt plats till fakturatjanst.coop.se. Du behöver uppdatera ditt bokmärke, länken här tar dig till administrationsportalen: ',

  'label.administratorExportFormat.XLSX': 'Excel (.xlsx)',
  'label.paymentPurchaserExportFormat.XLSX': 'Excel (.xlsx)',

  'label.purchaser_status.ACTIVE': 'Aktiv',
  'label.purchaser_status.PENDING_CARD_TOKEN':
    'Väntar på aktivering…uppdatera sidan för ny status',

  'label.invoice_recipient_customref1_example': '(t.ex. kostnadsställe)',
  'label.invoice_recipient_customref2_example': '(t.ex. ansvarsnummer)',

  'label.invoiceDeliveryMethod.EINVOICE_B2B': 'E-faktura B2B',
  'label.invoiceDeliveryMethod.PRINT_INVOICE': 'Pappersfaktura',
  'label.invoiceDeliveryMethod.MAIL_INVOICE': 'E-postfaktura',

  'label.invoiceFrequency.ONE_PER_MONTH': '1 gång per månad',
  'label.invoiceFrequency.TWO_PER_MONTH': '2 gånger per månad',

  'label.invoiceCountry.AD': 'Andorra',
  'label.invoiceCountry.AE': 'Förenade Arabemiraten',
  'label.invoiceCountry.AF': 'Afghanistan',
  'label.invoiceCountry.AG': 'Antigua och Barbuda',
  'label.invoiceCountry.AI': 'Anguilla',
  'label.invoiceCountry.AL': 'Albanien',
  'label.invoiceCountry.AM': 'Armenien',
  'label.invoiceCountry.AO': 'Angola',
  'label.invoiceCountry.AR': 'Argentina',
  'label.invoiceCountry.AS': 'Amerikanska Samoa',
  'label.invoiceCountry.AT': 'Österrike',
  'label.invoiceCountry.AU': 'Australien',
  'label.invoiceCountry.AW': 'Aruba',
  'label.invoiceCountry.AX': 'Åland',
  'label.invoiceCountry.AZ': 'Azerbajdzjan',
  'label.invoiceCountry.BA': 'Bosnien och Hercegovina',
  'label.invoiceCountry.BB': 'Barbados',
  'label.invoiceCountry.BD': 'Bangladesh',
  'label.invoiceCountry.BE': 'Belgien',
  'label.invoiceCountry.BF': 'Burkina Faso',
  'label.invoiceCountry.BG': 'Bulgarien',
  'label.invoiceCountry.BH': 'Bahrain',
  'label.invoiceCountry.BI': 'Burundi',
  'label.invoiceCountry.BJ': 'Benin',
  'label.invoiceCountry.BL': 'Saint-Barthélemy',
  'label.invoiceCountry.BM': 'Bermuda',
  'label.invoiceCountry.BN': 'Brunei',
  'label.invoiceCountry.BO': 'Bolivia',
  'label.invoiceCountry.BQ': 'Bonaire, Saint Eustatius och Saba',
  'label.invoiceCountry.BR': 'Brasilien',
  'label.invoiceCountry.BS': 'Bahamas',
  'label.invoiceCountry.BT': 'Bhutan',
  'label.invoiceCountry.BV': 'Bouvetön',
  'label.invoiceCountry.BW': 'Botswana',
  'label.invoiceCountry.BY': 'Vitryssland',
  'label.invoiceCountry.BZ': 'Belize',
  'label.invoiceCountry.CA': 'Kanada',
  'label.invoiceCountry.CC': 'Kokosöarna',
  'label.invoiceCountry.CD': 'Demokratiska republiken Kongo',
  'label.invoiceCountry.CF': 'Centralafrikanska republiken',
  'label.invoiceCountry.CG': 'Kongo-Brazzaville',
  'label.invoiceCountry.CH': 'Schweiz',
  'label.invoiceCountry.CI': 'Elfenbenskusten',
  'label.invoiceCountry.CK': 'Cooköarna',
  'label.invoiceCountry.CL': 'Chile',
  'label.invoiceCountry.CM': 'Kamerun',
  'label.invoiceCountry.CN': 'Kina',
  'label.invoiceCountry.CO': 'Colombia',
  'label.invoiceCountry.CR': 'Costa Rica',
  'label.invoiceCountry.CU': 'Kuba',
  'label.invoiceCountry.CV': 'Kap Verde',
  'label.invoiceCountry.CW': 'Curacao',
  'label.invoiceCountry.CX': 'Julön',
  'label.invoiceCountry.CY': 'Cypern',
  'label.invoiceCountry.CZ': 'Tjeckien',
  'label.invoiceCountry.DE': 'Tyskland',
  'label.invoiceCountry.DJ': 'Djibouti',
  'label.invoiceCountry.DK': 'Danmark',
  'label.invoiceCountry.DM': 'Dominica',
  'label.invoiceCountry.DO': 'Dominikanska republiken',
  'label.invoiceCountry.DZ': 'Algeriet',
  'label.invoiceCountry.EC': 'Ecuador',
  'label.invoiceCountry.EE': 'Estland',
  'label.invoiceCountry.EG': 'Egypten',
  'label.invoiceCountry.EH': 'Västsahara',
  'label.invoiceCountry.ER': 'Eritrea',
  'label.invoiceCountry.ES': 'Spanien',
  'label.invoiceCountry.ET': 'Etiopien',
  'label.invoiceCountry.FI': 'Finland',
  'label.invoiceCountry.FJ': 'Fiji',
  'label.invoiceCountry.FK': 'Falklandsöarna',
  'label.invoiceCountry.FM': 'Mikronesiska federationen',
  'label.invoiceCountry.FO': 'Färöarna',
  'label.invoiceCountry.FR': 'Frankrike',
  'label.invoiceCountry.GA': 'Gabon',
  'label.invoiceCountry.GB': 'Storbritannien',
  'label.invoiceCountry.GD': 'Grenada',
  'label.invoiceCountry.GE': 'Georgien',
  'label.invoiceCountry.GF': 'Franska Guyana',
  'label.invoiceCountry.GG': 'Guernsey',
  'label.invoiceCountry.GH': 'Ghana',
  'label.invoiceCountry.GI': 'Gibraltar',
  'label.invoiceCountry.GL': 'Grönland',
  'label.invoiceCountry.GM': 'Gambia',
  'label.invoiceCountry.GN': 'Guinea',
  'label.invoiceCountry.GP': 'Guadeloupe',
  'label.invoiceCountry.GQ': 'Ekvatorialguinea',
  'label.invoiceCountry.GR': 'Grekland',
  'label.invoiceCountry.GS': 'Sydgeorgien och Sydsandwichöarna',
  'label.invoiceCountry.GT': 'Guatemala',
  'label.invoiceCountry.GU': 'Guam',
  'label.invoiceCountry.GW': 'Guinea Bissau',
  'label.invoiceCountry.GY': 'Guyana',
  'label.invoiceCountry.HK': 'Hongkong',
  'label.invoiceCountry.HM': 'Heard- och McDonaldsöarna',
  'label.invoiceCountry.HN': 'Honduras',
  'label.invoiceCountry.HR': 'Kroatien',
  'label.invoiceCountry.HT': 'Haiti',
  'label.invoiceCountry.HU': 'Ungern',
  'label.invoiceCountry.ID': 'Indonesien',
  'label.invoiceCountry.IE': 'Irland',
  'label.invoiceCountry.IL': 'Israel',
  'label.invoiceCountry.IM': 'Isle of Man',
  'label.invoiceCountry.IN': 'Indien',
  'label.invoiceCountry.IO': 'Brittiska territoriet i Indiska Oceanen',
  'label.invoiceCountry.IQ': 'Irak',
  'label.invoiceCountry.IR': 'Iran',
  'label.invoiceCountry.IS': 'Island',
  'label.invoiceCountry.IT': 'Italien',
  'label.invoiceCountry.JE': 'Jersey',
  'label.invoiceCountry.JM': 'Jamaica',
  'label.invoiceCountry.JO': 'Jordanien',
  'label.invoiceCountry.JP': 'Japan',
  'label.invoiceCountry.KE': 'Kenya',
  'label.invoiceCountry.KG': 'Kirgizistan',
  'label.invoiceCountry.KH': 'Kambodja',
  'label.invoiceCountry.KI': 'Kiribati',
  'label.invoiceCountry.KM': 'Komorerna',
  'label.invoiceCountry.KN': 'Saint Kitts och Nevis',
  'label.invoiceCountry.KP': 'Nordkorea',
  'label.invoiceCountry.KR': 'Sydkorea',
  'label.invoiceCountry.KW': 'Kuwait',
  'label.invoiceCountry.KY': 'Caymanöarna',
  'label.invoiceCountry.KZ': 'Kazakstan',
  'label.invoiceCountry.LA': 'Laos',
  'label.invoiceCountry.LB': 'Libanon',
  'label.invoiceCountry.LC': 'Saint Lucia',
  'label.invoiceCountry.LI': 'Liechtenstein',
  'label.invoiceCountry.LK': 'Sri Lanka',
  'label.invoiceCountry.LR': 'Liberia',
  'label.invoiceCountry.LS': 'Lesotho',
  'label.invoiceCountry.LT': 'Litauen',
  'label.invoiceCountry.LU': 'Luxemburg',
  'label.invoiceCountry.LV': 'Lettland',
  'label.invoiceCountry.LY': 'Libyen',
  'label.invoiceCountry.MA': 'Marocko',
  'label.invoiceCountry.MC': 'Monaco',
  'label.invoiceCountry.MD': 'Moldavien',
  'label.invoiceCountry.ME': 'Montenegro',
  'label.invoiceCountry.MF': 'Saint Martin (franska delen)',
  'label.invoiceCountry.MG': 'Madagaskar',
  'label.invoiceCountry.MH': 'Marshallöarna',
  'label.invoiceCountry.MK': 'Nordmakedonien',
  'label.invoiceCountry.ML': 'Mali',
  'label.invoiceCountry.MM': 'Burma',
  'label.invoiceCountry.MN': 'Mongoliet',
  'label.invoiceCountry.MO': 'Macau',
  'label.invoiceCountry.MP': 'Nordmarianerna',
  'label.invoiceCountry.MQ': 'Martinique',
  'label.invoiceCountry.MR': 'Mauretanien',
  'label.invoiceCountry.MS': 'Montserrat',
  'label.invoiceCountry.MT': 'Malta',
  'label.invoiceCountry.MU': 'Mauritius',
  'label.invoiceCountry.MV': 'Maldiverna',
  'label.invoiceCountry.MW': 'Malawi',
  'label.invoiceCountry.MX': 'Mexiko',
  'label.invoiceCountry.MY': 'Malaysia',
  'label.invoiceCountry.MZ': 'Moçambique',
  'label.invoiceCountry.NA': 'Namibia',
  'label.invoiceCountry.NC': 'Nya Kaledonien',
  'label.invoiceCountry.NE': 'Niger',
  'label.invoiceCountry.NF': 'Norfolkön',
  'label.invoiceCountry.NG': 'Nigeria',
  'label.invoiceCountry.NI': 'Nicaragua',
  'label.invoiceCountry.NL': 'Nederländerna',
  'label.invoiceCountry.NO': 'Norge',
  'label.invoiceCountry.NP': 'Nepal',
  'label.invoiceCountry.NR': 'Nauru',
  'label.invoiceCountry.NU': 'Niue',
  'label.invoiceCountry.NZ': 'Nya Zeeland',
  'label.invoiceCountry.OM': 'Oman',
  'label.invoiceCountry.PA': 'Panama',
  'label.invoiceCountry.PE': 'Peru',
  'label.invoiceCountry.PF': 'Franska Polynesien',
  'label.invoiceCountry.PG': 'Papua Nya Guinea',
  'label.invoiceCountry.PH': 'Filippinerna',
  'label.invoiceCountry.PK': 'Pakistan',
  'label.invoiceCountry.PL': 'Polen',
  'label.invoiceCountry.PM': 'Saint-Pierre och Miquelon',
  'label.invoiceCountry.PN': 'Pitcairnöarna',
  'label.invoiceCountry.PR': 'Puerto Rico',
  'label.invoiceCountry.PT': 'Portugal',
  'label.invoiceCountry.PW': 'Palau',
  'label.invoiceCountry.PY': 'Paraguay',
  'label.invoiceCountry.QA': 'Qatar',
  'label.invoiceCountry.RE': 'Réunion',
  'label.invoiceCountry.RO': 'Rumänien',
  'label.invoiceCountry.RS': 'Serbien',
  'label.invoiceCountry.RU': 'Ryssland',
  'label.invoiceCountry.RW': 'Rwanda',
  'label.invoiceCountry.SA': 'Saudiarabien',
  'label.invoiceCountry.SB': 'Salomonöarna',
  'label.invoiceCountry.SC': 'Seychellerna',
  'label.invoiceCountry.SD': 'Sudan',
  'label.invoiceCountry.SE': 'Sverige',
  'label.invoiceCountry.SG': 'Singapore',
  'label.invoiceCountry.SH': 'Sankta Helena',
  'label.invoiceCountry.SI': 'Slovenien',
  'label.invoiceCountry.SJ': 'Svalbard och Jan Mayen',
  'label.invoiceCountry.SK': 'Slovakien',
  'label.invoiceCountry.SL': 'Sierra Leone',
  'label.invoiceCountry.SM': 'San Marino',
  'label.invoiceCountry.SN': 'Senegal',
  'label.invoiceCountry.SO': 'Somalia',
  'label.invoiceCountry.SR': 'Surinam',
  'label.invoiceCountry.SS': 'Sydsudan',
  'label.invoiceCountry.ST': 'São Tomé och Príncipe',
  'label.invoiceCountry.SV': 'El Salvador',
  'label.invoiceCountry.SX': 'Sint Maarten (nederländska delen)',
  'label.invoiceCountry.SY': 'Syrien',
  'label.invoiceCountry.SZ': 'Swaziland',
  'label.invoiceCountry.TC': 'Turks- och Caicosöarna',
  'label.invoiceCountry.TD': 'Tchad',
  'label.invoiceCountry.TF': 'Franska södra territorierna',
  'label.invoiceCountry.TG': 'Togo',
  'label.invoiceCountry.TH': 'Thailand',
  'label.invoiceCountry.TJ': 'Tadzjikistan',
  'label.invoiceCountry.TK': 'Tokelauöarna',
  'label.invoiceCountry.TL': 'Östtimor',
  'label.invoiceCountry.TM': 'Turkmenistan',
  'label.invoiceCountry.TN': 'Tunisien',
  'label.invoiceCountry.TO': 'Tonga',
  'label.invoiceCountry.TR': 'Turkiet',
  'label.invoiceCountry.TT': 'Trinidad och Tobago',
  'label.invoiceCountry.TV': 'Tuvalu',
  'label.invoiceCountry.TW': 'Taiwan',
  'label.invoiceCountry.TZ': 'Tanzania',
  'label.invoiceCountry.UA': 'Ukraina',
  'label.invoiceCountry.UG': 'Uganda',
  'label.invoiceCountry.UM': 'USAs yttre öar',
  'label.invoiceCountry.US': 'USA',
  'label.invoiceCountry.UY': 'Uruguay',
  'label.invoiceCountry.UZ': 'Uzbekistan',
  'label.invoiceCountry.VA': 'Vatikanstaten',
  'label.invoiceCountry.VC': 'Saint Vincent och Grenadinerna',
  'label.invoiceCountry.VE': 'Venezuela',
  'label.invoiceCountry.VG': 'Brittiska Jungfruöarna',
  'label.invoiceCountry.VI': 'Amerikanska Jungfruöarna',
  'label.invoiceCountry.VN': 'Vietnam',
  'label.invoiceCountry.VU': 'Vanuatu',
  'label.invoiceCountry.WF': 'Wallis- och Futunaöarna',
  'label.invoiceCountry.WS': 'Samoa',
  'label.invoiceCountry.YE': 'Jemen',
  'label.invoiceCountry.YT': 'Mayotte',
  'label.invoiceCountry.ZA': 'Sydafrika',
  'label.invoiceCountry.ZM': 'Zambia',
  'label.invoiceCountry.ZW': 'Zimbabwe',
  'label.invoiceCountry.XK': 'Kosovo',

  'label.search_country': 'Sök land...',

  'label.invoiceIntermediator.TIETO': 'Tieto Sverige (TIETO)',
  'label.invoiceIntermediator.ADDETT': 'Scancloud (ADDETT)',
  'label.invoiceIntermediator.BWEI': 'Basware (BWEI)',
  'label.invoiceIntermediator.LOGICA': 'CGI (LOGICA)',
  'label.invoiceIntermediator.LOGIQ': 'Logiq (LOGIQ)',
  'label.invoiceIntermediator.CLIENTCOMP': 'Compello (CLIENTCOMP)',
  'label.invoiceIntermediator.CREDIFLOW': 'Crediflow (CREDIFLOW)',
  'label.invoiceIntermediator.EDB': 'Evry/Tieto (EDB)',
  'label.invoiceIntermediator.EXPSYS': 'Expertsystems (EXPSYS)',
  'label.invoiceIntermediator.HANDSESS': 'Handelsbanken (HANDSESS)',
  'label.invoiceIntermediator.INEXCHANGE': 'Inexchange (INEXCHANGE)',
  'label.invoiceIntermediator.ITELLA': 'Itella Sverige/Opus Capita (ITELLA)',
  'label.invoiceIntermediator.ITELLAFI': 'Itella Finland (ITELLAFI)',
  'label.invoiceIntermediator.NDEASESS': 'Nordea (NDEASESS)',
  'label.invoiceIntermediator.PAGERO': 'Pagero (PAGERO)',
  'label.invoiceIntermediator.PALETTE': 'Palette (PALETTE)',
  'label.invoiceIntermediator.ESSESESS': 'SEB (ESSESESS)',
  'label.invoiceIntermediator.STRALFORS': 'Strålfors (STRALFORS)',
  'label.invoiceIntermediator.SWEDSESS': 'Swedbank (SWEDSESS)',
  'label.invoiceIntermediator.PROCEEDO': 'Visma Proceedo (PROCEEDO)',
  'label.invoiceIntermediator.PEAB': 'Peab (PEAB)',
  'label.invoiceIntermediator.PEPPOL': 'Peppol (PEPPOL)',
  'label.invoiceIntermediator.APIX': 'APIX (APIX)',
  'label.invoiceIntermediator.IBX': 'CAPGemini (IBX)',
  'label.invoiceIntermediator.EASYLINK': 'EasyLink (EASYLINK)',
  'label.invoiceIntermediator.TRUEC': 'Evenex/Hightjump/TrueCommerce (TRUEC)',
  'label.invoiceIntermediator.ENCODE': 'Encode (ENCODE)',
  'label.invoiceIntermediator.GLOBALEDI': 'Global EDI (GLOBALEDI)',
  'label.invoiceIntermediator.HDATA': 'Hantverksdata (HDATA)',
  'label.invoiceIntermediator.INTEGRS': 'Integrationssystemer (INTEGRS)',
  'label.invoiceIntermediator.KNOWE': 'Knowe (KNOWE)',
  'label.invoiceIntermediator.KMD': 'Kommunedata (KMD)',
  'label.invoiceIntermediator.LIAS': 'Liaison (LIAS)',
  'label.invoiceIntermediator.NEXMART': 'Nexmart (NEXMART)',
  'label.invoiceIntermediator.PIPECH': 'Pipechain (PIPECH)',
  'label.invoiceIntermediator.PRIHANDEL': 'Prihandel (PRIHANDEL)',
  'label.invoiceIntermediator.SATA': 'SATA (SATA)',
  'label.invoiceIntermediator.TELEMA': 'Telema (TELEMA)',
  'label.invoiceIntermediator.TELIA': 'Telia (TELIA)',
  'label.invoiceIntermediator.TELIASONERA': 'Teliasonera (TELIASONERA)',
  'label.invoiceIntermediator.VISMA': 'Visma (Maventa)',
  'label.invoiceIntermediator.VISMASNO': 'Visma Services Norge AS (VISMASNO)',
  'label.invoiceIntermediator.VISMASPCS': 'Visma Spcs (VISMASPCS)',
  'label.invoiceIntermediator.VISMAUAS': 'Visma Unique AS (VISMAUAS)',

  'label.invoice_delivery_addressee_id_hint':
    'Fyll i ditt GLN-nummer eller organisationsnummer. Vilket av dessa du ska ange beror på uppsättningen mellan er och er operatör (VAN). Vill du ta emot e-fakturor via PEPPOL ska du inte fylla i det inledande prefixen "0007:" eller "0088:" i ditt PEPPOL-id utan endast ditt GLN- eller organisationsnummer. ',
  'label.EINVOICE_B2B_hint':
    'Kräver att er organisation kan ta emot EDI-fakturor, t.ex. i formaten Svefaktura eller PEPPOL.',

  'label.invoiceGrouping.PER_TRANSACTION': 'Översikts\u00ADfaktura',
  'label.invoiceGrouping.PER_RECEIPT_ROW': 'Detaljerad faktura',

  'label.invoice_status_all': '(Alla)',
  'label.invoice_status_INVOICED': 'Obetald',
  'label.invoice_status_PAID': 'Betald',
  'label.invoice_status_UNPAID': 'Ej betalda',
  'label.invoice_status_REMINDER': 'Påminnelse',
  'label.invoice_status_COLLECTION': 'Inkasso',

  'label.login_select_account_title': 'Välj konto att administrera',

  'label.transactionExportFormat.XLSX': 'Excel (.xlsx)',
  'label.transactionExportFormat.ODS': 'OpenDocument Spreadsheet (.ods)',
   'label.dashboard.remaining_purchase_amount': 'Total inköpsgräns kvar att handla för',
  'label.dashboard.purchases_current_month': 'Inköp totalt denna månaden',
  'label.dashboard.purchases_per_invoice_recipient':
    'Inköp per fakturamottagare denna månaden',
  'label.dashboard.total_rebate': 'Total rabatt i år',
  'label.dashboard.no_purchases_current_month': 'Inga köp denna månad',
  'label.dashboard.no_purchases_per_invoice_recipient':
    'Ingen statistik för fakturamottagare',

  'label.select_account_title': 'Välj konto',

  'label.no_organization_admins_defined_message':
    'Inga organisations\u00ADadministratörer är definierade för det här kontot',
  'label.no_account_admins_defined_message':
    'Inga konto\u00ADadministratörer är definierade för det här kontot.',
  'label.no_invoice_recipient_admins_defined_message':
    'Inga faktura\u00ADmottagaradministratörer är definierade för den här faktura\u00ADmottagaren.',
  'label.no_invoice_recipients_defined_message':
    'Inga faktura\u00ADmottagare definierade för det här kontot.',
  'label.no_purchasers_defined_message':
    'Inga köpare är definierade för det här kontot.',
  'label.create_recipient_before_purchaser_message':
    'Du måste <a href="/admin/fakturamottagare/ny">skapa en fakturamottagare</a> innan du kan skapa köpare på kontot.',
  'label.no_invoices_for_orgaccount_message':
    'Inga fakturor hittade för det här kontot.',
  'label.no_invoices_for_filter': 'Inga fakturor hittades med det här filtret.',
  'label.no_transactions_for_orgaccount_message':
    'Inga inköp hittade för det här kontot.',
  'label.delete_purchaser_confirmation':
    'Är du säker på att du vill ta bort köparen?',
  'label.delete_admin_confirmation':
    'Är du säker på att du vill ta bort administratören?',
  'label.delete_recipient_confirmation':
    'Är du säker på att du vill ta bort ',
  'label.delete_invoice_recipient_first_message':
    'Om du tar bort en fakturamottagare tas all relaterad data (administratörer, köpare, fakturor och köp) bort. ',
  'label.delete_invoice_recipient_second_message':
    'Fakturamottagaren och relaterad data kan inte återställas. ',
  'label.delete_invoice_recipient_third_message':
    'Markera kryssrutan och klicka på Ta bort om du vill fortsätta.',
  'label.delete_invoice_recipient_admin_confirmation':
    'Är du säker på att du vill ta bort fakturamottagar\u00ADadministratören?',
  'label.delete_org_account_confirmation':
    'Är du säker på att du vill ta bort {orgAccountName}?',
  'label.delete_org_account_message':
    'Om du tar bort ett konto tas all relaterad data (adminstratörer, faktura\u00ADmottagare, köpare, fakturor och köp) bort.\n\nKontot och datan kan sedan inte återställas.\n\nMarkera kryssrutan och klicka på Ta bort om du vill fortsätta.',
  'label.read_and_agree': 'Jag har läst och godkänner',

  'label.page_footer':
    'Coop, \u00AD171\u00A088 Solna, \u00ADTelefon: 010\u2013742\u00A000\u00A000, \u00ADOrg.nr: 556710\u20135480',

  'label.create_new_account_hint':
    'Namnet på kontot bör vara tex. Avdelnings\u00ADnamn, förvaltnings\u00ADområdes\u00ADnamn etc.',
  'label.name_in_app_hint':
    'Avser namnet på kostnadsstället som visas i mobilappen',
  'label.purchaser_hint':
    'Klicka på en köprad för att visa kvittoinformationen',
  'label.to_help_page': 'Läs vår guide',

  'label.update_organization': 'Uppdatera organisationen',
  'label.cannot_be_edited': 'Kan inte ändras',
  'label.contact_customer_service': 'För att ändra, kontakta kundtjänst',

  'label.reference_person_hint':
    'Referensperson i er organisation. Om ni har e-faktura via Peppol mappas detta mot fältet <strong>BT-56 Buyer contact point</strong>',
  'label.reference_order_hint':
    'Om ni har e-faktura via Peppol mappas detta mot fältet <strong>BT-13 Purchase order reference</strong>',
  'label.reference_buyer_hint':
    'Om ni har e-faktura via Peppol mappas detta mot fältet <strong>BT-10 Buyer reference</strong>',
  'label.reference_contract_hint':
    'Avtals/kontraktsreferens. Om ni har e-faktura via Peppol mappas detta mot fältet <strong>BT-12 Contract reference</strong>',

  // Toasts
  'alert.organization_admin_created': 'Organisationsadministratör skapad',
  'alert.organization_admin_edited': 'Organisationsadministratör ändrad',
  'alert.organization_admin_deleted': 'Organisationsadministratör borttagen',
  'alert.account_created': 'Organisationskonto skapat',
  'alert.account_edited': 'Organisationskonto ändrat',
  'alert.account_administrator_created': 'Kontoadministratör skapad',
  'alert.account_administrator_edited': 'Kontoadministratör ändrad',
  'alert.account_administrator_deleted': 'Kontoadministratör borttagen',
  'alert.not_allowed_to_delete_last_account':
    'Det går inte att ta bort organisationens sista konto',
  'alert.invoice_recipient_created': 'Fakturamottagare skapad',
  'alert.invoice_recipient_edited': 'Fakturamottagare ändrad',
  'alert.invoice_recipient_deleted': 'Fakturamottagare borttagen',
  'alert.purchaser_created': 'Köpare skapad',
  'alert.purchaser_edited': 'Köpare ändrad',
  'alert.purchaser_deleted': 'Köpare borttagen',
  'alert.invoice_recipient_admin_deleted':
    'Fakturamotagaradministratören borttagen',
  'alert.invoice_recipient_admin_created':
    'Fakturamottagaradministratör skapad',
  'alert.invoice_recipient_admin_edited': 'Fakturamottagaradministratör ändrad',

  // Errors & warnings
  'alert.ORG_ADMIN_NOT_FOUND': 'Kunde inte hitta organisationsadministratör.',
  'alert.COULD_NOT_CREATE_ACCOUNT': 'Kunde inte skapa konto',
  'alert.COULD_NOT_UPDATE_ACCOUNT': 'Kunde inte ändra konto',
  'alert.COULD_NOT_CREATE_ORGANIZATION_ACCOUNT':
    'Kunde inte skapa nytt organisationskonto',
  'alert.COULD_NOT_CREATE_ORGANIZATION_ADMIN':
    'Kunde inte skapa organisationsadministratör',
  'alert.COULD_NOT_CREATE_PURCHASER': 'Kunde inte skapa köpare',
  'alert.PERSON_ALREADY_PURCHASER':
    'Personen är redan upplagd som köpare. Vid behov, uppdatera sidan med köpare eller logga in på nytt.',
  'alert.COULD_NOT_UPDATE_PURCHASER': 'Kunde inte ändra köpare',
  'alert.COULD_NOT_SHOW_TRANSACTION':
    'Ett fel har uppstått med köpet och det kan inte visas',
  'alert.CANNOT_DELETE_OWN_ADMIN_ACCOUNT':
    'Du kan inte ta bort ditt eget administratörskonto',
  'alert.PERSON_ALREADY_INVOICE_RECIPIENT_ADMIN':
    'Personen är redan fakturamottagaradministratör. Ta bort den rollen innan du kan tilldela denna administratörsroll.',
  'alert.PERSON_ALREADY_ORG_ADMIN':
    'Personen är redan organisationsadministratör. Ta bort den rollen innan du kan tilldela denna administratörsroll.',
  'alert.PERSON_ALREADY_ACCOUNT_ADMIN':
    'Personen är redan kontoadministratör. Ta bort den rollen innan du kan tilldela denna administratörsroll.',
  'alert.ORGANIZATION_NOT_FOUND': 'Organisationen kan inte hittas',
  'alert.ORG_ACCOUNT_NOT_FOUND': 'Organisationskontot kan inte hittas',
  'alert.INVOICE_RECIPIENT_NOT_FOUND': 'Fakturamottagaren kan inte hittas',
  'alert.ORG_ACCOUNT_INVOICE_RECIPIENT_MISMATCH':
    'Angiven fakturamottagare hör ej till angivet organisationskonto',
  'alert.COULD_NOT_CREATE_INVOICE_RECIPIENT':
    'Kunde inte skapa fakturamottagare',
  'alert.COULD_NOT_EDIT_INVOICE_RECIPIENT':
    'Kunde inte uppdatera fakturamottagaren',
  'alert.COULD_NOT_DELETE_INVOICE_RECIPIENT':
    'För att ta bort fakturamottagren måste du först ta bort den eller de kopplade fakturamottagaradministratörerna',

  // Validation
  'validation.orgAccountNameAlreadyExists':
    'Det finns redan ett konto med detta namn',
  'validation.invoiceRecipientNameAlreadyExists':
    'Det finns redan en mottagare med detta namn',
  'validation.invoiceRecipientsError':
    'Minst en fakturamottagare måste vara vald, alla valda måste ha Inköpsgräns',
  'validation.invalidAddresseeId': 'Kan endast bestå av numeriska tecken.',
})

export { options, translations }
